<script setup>
import PlaylistsTableTile from '@components/playlists/playlists-table-tile'
import modalService from '@/services/modal-service'
import { useAuthStore } from '@state/stores/auth'

defineProps({
    mixes: {
        type: Array,
        default: () => [],
    },
    genres: {
        type: Boolean,
        default: false,
    },
    isIndexedList: {
        type: Boolean,
        default: false,
    },
    buttons: {
        type: Object,
        default: () => {},
    },
    error: {
        type: [Object, Boolean],
        default: false,
    },
    shouldTransition: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['playPlaylistMix'])

const authStore = useAuthStore()

function playPlaylistMix(index) {
    if (!authStore.loggedIn) {
        modalService.show('AUTH_REQUIRED_FOR_PLAYBACK')
        return
    }
    emit('playPlaylistMix', index)
}
</script>

<template>
    <div>
        <transition-group
            :name="shouldTransition ? 'slowfade' : 'no-transition'"
            tag="div"
        >
            <PlaylistsTableTile
                v-for="(mix, index) in mixes"
                :key="'playlist' + mix.id + index"
                :mix="mix"
                :index="index"
                :genres="genres"
                :buttons="buttons"
                :is-indexed-list="isIndexedList"
                is-playlist-mix
                @play-playlist-mix="playPlaylistMix(index)"
            />
        </transition-group>

        <BaseEmptyList
            v-if="mixes.length === 0 && error"
            :error="error"
        />
    </div>
</template>
